export default class InvalidCredentialsError extends Error {
    constructor(recoveryPassword) {
        super('must_reset_password');

        this.recoveryPassword = recoveryPassword;
    }
}
